module.exports = __webpack_public_path__ + "img/Auto.252261a4.jpg";